module.exports = __webpack_public_path__ + "img/intern-logbook-chatbot-thumbnail.2ad1b53e.png";